import { createClient } from '@supabase/supabase-js';

// Public anon key is safe to ship — every admin edge function calls
// requireAdmin() server-side, so the client's belief about admin status
// grants no actual data access.
const url  = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anon) {
  // Fail loud in dev; a misconfigured deploy is worse than a broken build.
  throw new Error(
    'VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY missing. Copy .env.example → .env and fill in values.'
  );
}

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Magic-link callback lands on the same host, no separate redirect page.
    flowType: 'pkce',
  },
});
